import { SECONDARY_VIEW_KEYS } from './secondaryNavBody.js'

export const secondaryNavSchemasHome = {
  home: {
    headerTitle: 'Home',
    highlighted: true,
    shellVariant: 'home',
    views: {
      [SECONDARY_VIEW_KEYS.HOME_MAIN]: [
        { type: 'boardsPreview' },
        { type: 'appsPreview' },
        { type: 'newChatAction', label: 'New Agent' },
        { type: 'homeThreadsRail' },
      ],
      [SECONDARY_VIEW_KEYS.HOME_BOARDS_ALL]: [{ type: 'boardsLanding' }],
    },
    initialView: SECONDARY_VIEW_KEYS.HOME_MAIN,
  },
}
